<template>
    <fragment>
        <th>
            <panorama-header-item title="Taux" />
        </th>
        <th>
            <panorama-header-item title="Répartition" />
        </th>
        <th>
            <panorama-header-item title="CSP" />
        </th>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import PanoramaHeaderItem from "../../PanoramaHeaderItem.vue";

export default {
    components: { Fragment, PanoramaHeaderItem },
    props: ["subject"],
};
</script>

<style scoped lang="sass"></style>
